// all api urls in one place
export const CATEGORY_API = "https://gitstool.in/liquor/shop_app/fetch_categories.php";
export const PRODUCT_API = "https://gitstool.in/liquor/shop_app/product_details.php?cat_id=${cat_id}";
export const POPULAR_API = "https://gitstool.in/liquor/shop_app/product_details.php?pop_id=1";
export const ALL_PRODUCTS_API = "https://gitstool.in/liquor/shop_app/product_details.php";
export const FAVORITES_API = "https://gitstool.in/liquor/shop_app/submit_favorites.php";
export const NOTIFICATIONS_API= "https://gitstool.in/liquor/shop_app/register_brand_notification.php"
export const IMAGE_BASE_URL = "https://gitstool.in/liquor/shop_app/";
export const BASE_URL = "https://gitstool.in/liquor/shop_app/";